import { normalizeNullValue } from '../address.utils';

export const floorField = {
    read(value) {
        return normalizeNullValue(value);
    },
};
